import { render, staticRenderFns } from "./section-features-with-number.vue?vue&type=template&id=6fb8a4f4&scoped=true"
import script from "./section-features-with-number.vue?vue&type=script&lang=js"
export * from "./section-features-with-number.vue?vue&type=script&lang=js"
import style0 from "./section-features-with-number.vue?vue&type=style&index=0&id=6fb8a4f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb8a4f4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VIcon: require('/var/www/tubber-new/components/global/v/icon.vue').default})
